import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { ApiResponse } from '@core/models/interfaces';
import { Observable } from 'rxjs';
import { ApiService } from '../common';
import { SetForceLogoutVersionByOfficeRequest } from '@pages/authorized/careposi/organization-management/organization-management.model';

@Injectable({
  providedIn: 'root',
})
export class CorpInfoService {
  constructor(private readonly http: ApiService) {}

  getAllCorp(): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.getAllCorp}`;
    return this.http.get(url);
  }

  getListMapInfo(): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.getListMapInfo}`;
    return this.http.get(url);
  }

  getAllOrgMapInfo(): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.getAllOrgMapInfo}`;
    return this.http.get(url);
  }

  getBusinessMapping(mapId: string): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.getBusinessMapping}?mapId=${mapId}`;
    return this.http.get(url);
  }

  updateMapInfoData(body: any): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.updateMapRowData}`;
    return this.http.post(url, body);
  }

  createMapInfo(body: any): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.createMap}`;
    return this.http.post(url, body);
  }

  updateMapDetailInfo(body: any): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.updateMapDetailInfo}`;
    return this.http.post(url, body);
  }

  deleteMapInfoData(body: any): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.deleteMapRowData}`;
    return this.http.post(url, body);
  }

  syncMapInfoData(body: any): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.syncMapInfoData}`;
    return this.http.post(url, body);
  }

  fetchOfficesByOrganizationId(orgIds: number[]): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.getOfficeByOrganizationIds}`;
    return this.http.post(url, orgIds);
  }

  updateToDynamoDB(body: any): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.updateDynamoDB}`;
    return this.http.post(url, body);
  }

  setForceLogoutVersionByOffice(body: SetForceLogoutVersionByOfficeRequest): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.setForceLogoutVersionByOffice}`;
    return this.http.post(url, body);
  }
}
